import React, { useContext } from 'react'

import { UserContext } from '@doist/marketist'

import { Footer, Navbar, Seo } from 'components'
import { Manifesto } from 'components/Manifesto/Manifesto'
import { SlackAltCTA } from 'components/slack-alternative/SlackAltCTA/SlackAltCTA'
import { GetServerSidePropsContext } from 'next/types'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCommonServerSideProps } from 'services'
import { getOgImageURL } from 'services/ogimage'

function Async() {
    const { isAuthenticated } = useContext(UserContext)
    const { t, i18n } = useTranslation('async')

    return (
        <>
            <Navbar isAuth={isAuthenticated} />
            <Seo
                path="/async"
                title={t('seoTitle')}
                description={t('seoDescription')}
                lang={i18n.language}
                images={[
                    {
                        url: getOgImageURL('og-image-why-async.jpg'),
                        alt: t('seoImageAlt'),
                    },
                ]}
            />
            <Manifesto />
            <SlackAltCTA />
            <Footer hairlineBackgroundColor="var(--ui-border)" />
        </>
    )
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    const { locale, ...commonProps } = await getCommonServerSideProps(ctx)
    return {
        props: {
            ...commonProps,
            ...(await serverSideTranslations(locale, ['async', 'slackalternative', 'common'])),
        },
    }
}

export default Async
